import { DownloadIcon, LoaderIcon } from "lucide-react"
import React from "react"

import { Button, type ButtonProps } from "../ui/button"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip"
interface DownloadButtonProps extends ButtonProps {
  isDownloading: boolean
  tooltipText?: string
}
const DownloadButton: React.FC<DownloadButtonProps> = ({
  isDownloading,
  tooltipText,
  ...props
}) => {
  const iconSize = props.size === "sm" ? 18 : 16
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button
              variant={props.variant}
              disabled={isDownloading}
              onClickCapture={props.onClickCapture}
              {...props}
            >
              {isDownloading ? (
                <LoaderIcon
                  size={iconSize}
                  className="animate-spin"
                />
              ) : (
                <DownloadIcon size={iconSize} />
              )}
              {isDownloading
                ? "Fazendo download ..."
                : props.children}
            </Button>{" "}
          </div>
        </TooltipTrigger>
        {tooltipText && (
          <TooltipContent>
            <p className="max-w-40 text-xs">
              {tooltipText}
            </p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  )
}
export default DownloadButton
